
import type { SVGProps } from 'react';
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={23} {...props}>
    <path
      fill="#253E6A"
      fillRule="nonzero"
      d="M9.807 11.668a5.796 5.796 0 0 1-5.79-5.79A5.796 5.796 0 0 1 9.807.09a5.796 5.796 0 0 1 5.79 5.79 5.796 5.796 0 0 1-5.79 5.79m0-10.59a4.805 4.805 0 0 0-4.8 4.8c0 2.647 2.154 4.8 4.8 4.8s4.8-2.153 4.8-4.8-2.154-4.8-4.8-4.8m9.583 21.225v-3.188a5.943 5.943 0 0 0-5.935-5.936H6.162a5.943 5.943 0 0 0-5.936 5.936v3.188c0 .272.223.494.495.494a.496.496 0 0 0 .494-.494v-3.188a4.95 4.95 0 0 1 4.947-4.947h7.293a4.95 4.95 0 0 1 4.946 4.947v3.188c0 .272.223.494.495.494a.496.496 0 0 0 .494-.494"
    />
  </svg>
);
export default SvgSettings;
